import { Component, OnInit } from '@angular/core';
import {TipoQuimicos} from '../../../models/tipo-quimicos.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  selector: 'app-lista-inscripcion-publicidad',
  templateUrl: './lista-inscripcion-publicidad.component.html',
  styleUrls: ['./lista-inscripcion-publicidad.component.css']
})
export class ListaInscripcionPublicidadComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Publicidad',
      routerLink: '/publicidad'
    }
  ];

  tipos: TipoQuimicos[];
  loading = false;

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposPublicidad().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }

}
